<!--  -->
<template>
  <section class="">
    <ActionBar>
      <!-- <btnTel
        slot="icons"
        v-if="product.businessPhone"
        @tel="tel(product.businessPhone)"
      ></btnTel> -->
      <button
        class="btns btn-pink btn-detail"
        slot="buttons"
        @click="confirmBuy"
        v-if="buyButtonEnable"
      >
        购买
      </button>
      <button
        class="btns btn-grey btn-detail"
        slot="buttons"
        v-else-if="isSoldOut"
      >
        已售罄
      </button>
      <button class="btns btn-grey btn-detail" slot="buttons" v-else>
        暂不提供服务
      </button>
      <!-- <button class="btns btn-grey btn-detail" slot="buttons">
        暂不提供服务
      </button> -->
    </ActionBar>
  </section>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import ActionBar from './actionbar'
import { mapState } from 'vuex'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    ActionBar
  },
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState(['product']),
    buyButtonEnable() {
      return false
    },
    isSoldOut() {
      return false
    }
  },
  //监控data中的数据变化
  watch: {
    product() {
      console.log('pro', this.product)
    }
  },
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log('product is ', this.product)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
//@import url(); 引入公共css类
</style>
